import { detectPriority } from './taskUtils';
import { withRequiresDocumentation } from './taskDocumentation';

const RECURRING_PATTERN = /every|hourly|daily|twice|كل ساعة|يومياً|يوميا/i;
const CONDITIONAL_PATTERN =
  /^(if|إذا|لو)\b/i;

function stableHash(text) {
  let hash = 0;
  const raw = String(text || '');
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash << 5) - hash + raw.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

export function isRecurringIntervention(text) {
  return RECURRING_PATTERN.test(String(text || ''));
}

export function isConditionalIntervention(text) {
  const value = String(text || '').trim();
  if (!value) return false;
  if (CONDITIONAL_PATTERN.test(value)) return true;
  return /\bif\b.+(—|-|–|:|then|give|notify|ابلغ)/i.test(value);
}

export function carePlanInterventionTaskId(carePlanId, intervention, index) {
  return `cp-${carePlanId}-${index}-${stableHash(intervention)}`;
}

export function createCarePlanInterventionTask(patientId, carePlanId, intervention, index) {
  const title = String(intervention || '').trim();
  if (!title) return null;

  const recurring = isRecurringIntervention(title);
  const conditional = isConditionalIntervention(title);

  return withRequiresDocumentation({
    id: carePlanInterventionTaskId(carePlanId, title, index),
    patientId,
    type: 'care_plan',
    title,
    dueTime: null,
    windowStart: null,
    windowEnd: null,
    status: 'ongoing',
    completedAt: null,
    completedByNoteId: null,
    completionMode: 'manual',
    sourceNoteType: null,
    source: 'care_plan',
    carePlanId,
    interventionIndex: index,
    isRecurring: recurring,
    isPrn: conditional,
    priority: detectPriority(title),
  });
}

export function tasksFromCarePlan() {
  // Care-plan interventions must not generate patient tasks.
  return [];
}

/**
 * Care-plan interventions are documentation only — never spawn or merge tasks.
 */
export function mergeCarePlanInterventionTasks(existingTasks = []) {
  return Array.isArray(existingTasks) ? existingTasks : [];
}

export function getTaskSourceKind(task) {
  if (!task) return 'manual';
  if (task.source === 'voice' || task.type === 'generated') return 'voice';
  if (task.source === 'care_plan' || task.type === 'care_plan') return 'care_plan';
  return 'manual';
}

export function isMedicationTask(task) {
  return task?.sourceNoteType === 'medication_admin';
}

export function isPrnTask(task) {
  if (!task) return false;
  if (task.isPrn) return true;
  if (task.type === 'care_plan' && isConditionalIntervention(task.title)) return true;
  if (task.type === 'generated' && isConditionalIntervention(task.title)) return true;
  return false;
}
